// Единственный источник правды — общий пакет: две копии с разъезжающимися границами уже
// приводили к тому, что CSS и JS считали планшет по-разному (WSL-8).
export {
  getResolution,
  isDesktop,
  isMobile,
  isNotDesktop,
  isNotMobile,
  isTablet,
} from '@ws/shared/utils';
export type { TResolutionName } from '@ws/shared/utils';
